import { WorkList } from "../../components/WorkList/WorkList";

import "./Work.css";

export const Work = () => {
	return (
		<div className='work-page'>
			<WorkList />
		</div>
	);
};
